import * as React from "react";
import { useCurrentCase } from "duck";
import { getJaw } from "./utils";

export const useGetActionsProps = ({
  selected,
  setSelected
}: {
  selected: number[];
  setSelected: React.Dispatch<React.SetStateAction<number[]>>;
}) => {
  const { dentalChartings, species, milkOrAdultTeeth } = useCurrentCase(
    ({ data }) => ({
      dentalChartings: data.client.patient.dentalChartings,
      species: data.client.patient.species || null,
      milkOrAdultTeeth:
        data.client.patient.generalAssessment?.dentalChart || null
    })
  );

  return (section: 1 | 2 | 3 | 4) => {
    const jaw = getJaw(species, milkOrAdultTeeth);
    const jawQuater = jaw ? jaw[section] : [];

    return {
      selection: jawQuater
        .filter(id => selected.includes(id))
        .map(id => dentalChartings?.find(chart => chart.tooth === id))
        .filter(Boolean) as any,
      onDeselectAll() {
        setSelected(prev => prev.filter(id => !jawQuater.includes(id)));
      }
    };
  };
};
